export const PASSWORDLESS_SIGNUP_CONTENT_KEYS = Object.freeze({
  COMMIT: Object.freeze({
    DEFAULT: 'buttons.poma.continueAsMemberAndPay',
    EXISTING_MEMBER_ACCOUNT_BASED_CTA_V1: 'buttons.poma.payNowAndCreateAccount',
  }),
  DEFAULT: Object.freeze({
    DEFAULT: 'buttons.poma.continueAsMember',
    EXISTING_MEMBER_ACCOUNT_BASED_CTA_V1:
      'buttons.poma.continueAndCreateAccount',
  }),
});

/** freezing features list so its immutable and keys cannot be edited */
export const TREATMENTS = Object.freeze({
  /**@deprecated - use FEATURE_OECD_CRS_ENABLEMENT instead */
  FEATURE_CRS_DATA_COLLECTION: 'FEATURE_CRS_DATA_COLLECTION',
  FEATURE_EXPAND_MEMBER_MATCHING_WPS: 'FEATURE_EXPAND_MEMBER_MATCHING_WPS',
  FEATURE_OECD_CRS_ENABLEMENT: 'FEATURE_OECD_CRS_ENABLEMENT',
  FEATURE_PP_REACT_MOCK_STYLES: 'FEATURE_PP_REACT_MOCK_STYLES',
  FEATURE_SIGNUP_MANDATORY_PHONE_CONFIRMATION:
    'FEATURE_SIGNUP_MANDATORY_PHONE_CONFIRMATION',
  FEATURE_STOP_ADDRESS_PREFILL: 'FEATURE_STOP_ADDRESS_PREFILL',
  FEATURE_SUPPRESS_BANK_FUNDED_GUEST_PAYMENTS:
    'FEATURE_SUPPRESS_BANK_FUNDED_GUEST_PAYMENTS',
  FEATURE_WPS_PASSWORDLESS: 'FEATURE_WPS_PASSWORDLESS',
});

/* Checkbox ids/names that rely on feature flags*/
export const MARKETING_OPT_IN = 'marketingOptIn';
export const SIGNUP_AGREE_TO_TERMS = 'signupAgreeToTerms';
export const SIGNUP_AGREE_TO_PRIVACY_STATEMENTS =
  'signupAgreePrivacyStatements';
export const UNIQUE_INFORMATION_PROCESSING = 'uniqueInformationProcessing';
export const THIRD_PARTY_DATA_CONSENT = 'thirdPartyDataConsent';
